import { useState, useEffect } from "react";
import {
  Box,
  Button,
  FormControl,
  FormHelperText,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import RFQOverview from "./RFQOverview";
import TradeTransactionDetails from "./TradeTransactionDetails";
import InstrumentTerms from "./InstrumentTerms";
import DocumentRequirements from "./DocumentRequirements";
import Attachments from "./Attachments";
import TermsTiming from "./TermsTiming";
import { validateForm } from "./formUtils";


const TabForm = ({
  activeTab,
  setActiveTab,
  fileUrl,
  formData,
  setFormData,
  errors,
  setErrors,
  handleChange,
  handleSubmit,
  handleReset,
  handleAdd,
  isEditMode,
  isInstrumentSelected,
  formMode,
  currentDate,
  countrymaster,
  incotermsMaster,
  paymentTermMaster,
  loadFormPorts,
  formOriginPortList,
  formDeliveryPortList,
  openProformaModal,
  handleOpenProformaModal,
  openTradeModal,
  handleOpenTradeModal,
  openKycModal,
  handleOpenKycModal,
  openTradeRFQModal,
  handleCloseTradeRFQModal,
  buyerInfo,
  activeUser,
  handleOpenTradeRFQModal,
  selectedTradeRFQ,
  setModal
}) => {
  const handleFieldChange = (e) => {
    const { name, value, type, checked } = e.target;
    const newFormData = {
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    };
    handleChange(e); // This updates the parent state
    // const updatedErrors = validateForm(newFormData, formData.instrument);
    // setErrors(updatedErrors);
  };

  useEffect(() => {
    if (formData.instrument) {
    //   const updatedErrors = validateForm(formData, formData.instrument);
    //   setErrors(updatedErrors);
    }
  }, [formData.instrument, formData.lcType, setErrors]);

  const handleFormSubmit = (e) => {
    e.preventDefault();
    const validationErrors = validateForm(formData, formData.instrument);
    setErrors(validationErrors);
    if (Object.keys(validationErrors).length > 0) {
      console.log('open modal');
      setModal({
        show: true,
        type: "error",
        title: "Validation Error",
        message:
          "Please fill in all required fields: " +
          Object.values(validationErrors).join(", "),
        autoClose: false,
      });
    }

    if (Object.keys(validationErrors).length === 0) {
      handleSubmit(e);
    } else {
      console.log("Validation errors:", validationErrors);
    }
  };

  const handleTabClick = (tabNumber) => {
    setActiveTab(tabNumber);
  };

  const getFormTitle = () => {
    if (formMode === "view") {
      return `View RFQ - ${formData.RfqId || ""}`;
    } else if (isEditMode) {
      return `Edit RFQ - ${formData.RfqId || ""}`;
    } else {
      return "Add RFQ";
    }
  };

  const excludeList = [
    "Buyer's Credit / Trade Loan",
    "Documentary Collection (D/P or D/A)",
    "Open Account with Credit Insurance",
  ];

  return (
    <div className="tab-content-main">
      <div className="table-header">
        <div className="header-text">
          <div className="head-text">{getFormTitle()}</div>
        </div>
        <div className="select-filter-box">
          <FormControl fullWidth error={!!errors.instrument}>
            <Box>
              <Typography
                sx={{
                  width: "100%",
                  color: "#de6b14",
                  fontSize: "14px",
                }}
              >
                Select Instrument *
              </Typography>
              <Select
                name="instrument"
                value={formData.instrument || ""}
                onChange={handleFieldChange}
                disabled={formMode === "view"}
                size="small"
                placeholder="Select Instrument"
                sx={{
                  backgroundColor: "white",
                  borderRadius: "4px",
                  "& .MuiSelect-select": { padding: "8px 14px" },
                  minWidth: 230,
                }}
                inputProps={{ "aria-label": "Select Instrument" }}
              >
                <MenuItem value="" disabled>
                  Select Instrument
                </MenuItem>
                {[
                  "Letter of Credit (LC) - Sight / Usance / Back-to-Back",
                  "Deferred Payment Terms with LC",
                  "Bank Guarantee (BG) - Payment / Performance",
                  "Standby Letter of Credit (SBLC)",
                  "Buyer's Credit / Trade Loan",
                  "Documentary Collection (D/P or D/A)",
                  "Open Account with Credit Insurance",
                ].map((option) => (
                  <MenuItem key={option} value={option}>
                    {option}
                  </MenuItem>
                ))}
              </Select>
            </Box>
            {errors.instrument && (
              <FormHelperText>{errors.instrument}</FormHelperText>
            )}
          </FormControl>
        </div>

        <div className="head-btn">
          {isInstrumentSelected &&
            !excludeList.includes(formData.instrument) &&
            formMode !== "view" && (
              <>
                {!isEditMode && formMode !== "view" && (
                  <div className="head-btn">
                    <Button
                      onClick={() => {
                        console.log("Generate from Trade RFQ button clicked");
                        handleOpenTradeRFQModal();
                      }}
                      className="submit-btn-more"
                      disabled={!formData.instrument}
                      sx={{
                        marginRight: 1,
                        backgroundColor: !formData.instrument
                          ? "#ccc !important"
                          : "#de6b14 !important",
                        color: "#fff !important",
                        height: "38px",
                        "&:hover": {
                          backgroundColor: !formData.instrument
                            ? "#ccc !important"
                            : "#de6b14 !important",
                          color: "#fff !important",
                        },
                      }}
                    >
                      Generate from Trade RFQ
                    </Button>
                  </div>
                )}

                {!isEditMode && (
                  <button
                    type="button"
                    className="submit-btn-more"
                    onClick={handleReset}
                    aria-label="Reset RFQ form"
                  >
                    RESET
                  </button>
                )}
                <button
                  type="button"
                  className="submit-btn-more"
                  onClick={handleAdd}
                  aria-label="Cancel RFQ form"
                >
                  CANCEL
                </button>
                <button
                  type="submit"
                  className="submit-btn-more"
                  onClick={handleFormSubmit}
                  aria-label={isEditMode ? "Edit RFQ" : "Submit RFQ form"}
                >
                  {isEditMode ? "UPDATE" : "SUBMIT"}
                </button>
              </>
            )}
        </div>
      </div>
      {isInstrumentSelected &&
        (excludeList.includes(formData.instrument) ? (
          <div className="coming-soon">
            <h2>Coming Soon!</h2>
          </div>
        ) : (
          <>
            <div className="tabs" role="tablist">
              {[
                "RFQ Overview",
                "Trade & Transaction Details",
                "Instrument Terms",
                "Document Requirements",
                "Attachments",
                "Terms & Timing",
              ].map((tab, index) => (
                <button
                  key={index}
                  role="tab"
                  aria-selected={activeTab === index + 1}
                  className={activeTab === index + 1 ? "active" : ""}
                  onClick={() => handleTabClick(index + 1)}
                >
                  {tab}
                </button>
              ))}
            </div>

            <div className="tab-content">
              <form onSubmit={handleFormSubmit}>
                {activeTab === 1 && (
                  <RFQOverview
                    formData={formData}
                    errors={errors}
                    handleChange={handleFieldChange}
                    formMode={formMode}
                    currentDate={currentDate}
                    countrymaster={countrymaster}
                    incotermsMaster={incotermsMaster}
                    paymentTermMaster={paymentTermMaster}
                    loadFormPorts={loadFormPorts}
                    selectedTradeRFQ={selectedTradeRFQ}
                    buyerInfo={buyerInfo}
                  />
                )}

                {activeTab === 2 && (
                  <TradeTransactionDetails
                    formData={formData}
                    errors={errors}
                    handleChange={handleFieldChange}
                    formMode={formMode}
                    currentDate={currentDate}
                    formOriginPortList={formOriginPortList}
                    formDeliveryPortList={formDeliveryPortList}
                    incotermsMaster={incotermsMaster}
                    selectedTradeRFQ={selectedTradeRFQ}
                  />
                )}

                {activeTab === 3 && (
                  <InstrumentTerms
                    formData={formData}
                    setFormData={setFormData} // Added
                    errors={errors} // Added
                    setErrors={setErrors} // Added
                    handleChange={handleFieldChange}
                    formMode={formMode}
                    selectedTradeRFQ={selectedTradeRFQ}
                  />
                )}

                {activeTab === 4 && (
                  <DocumentRequirements
                    formData={formData}
                    setFormData={setFormData}
                    formMode={formMode}
                    errors={errors}
                    setErrors={setErrors}
                    handleChange={handleFieldChange}
                    selectedTradeRFQ={selectedTradeRFQ}
                  />
                )}

                {activeTab === 5 && (
                  <Attachments
                    formData={formData}
                    setFormData={setFormData}
                    fileUrl={fileUrl}
                    formMode={formMode}
                    errors={errors}
                    setErrors={setErrors}
                    handleOpenProformaModal={handleOpenProformaModal}
                    handleOpenTradeModal={handleOpenTradeModal}
                    handleOpenKycModal={handleOpenKycModal}
                    selectedTradeRFQ={selectedTradeRFQ}
                  />
                )}

                {activeTab === 6 && (
                  <TermsTiming
                    formData={formData}
                    handleChange={handleFieldChange}
                    formMode={formMode}
                    currentDate={currentDate}
                    errors={errors}
                    setErrors={setErrors}
                    selectedTradeRFQ={selectedTradeRFQ}
                  />
                )}
              </form>
            </div>
          </>
        ))}
    </div>
  );
};

export default TabForm;
